import { useTranslation } from 'react-i18next';
import { assertUnreachable } from '@levelworks/shared-utils-ts';
import { ServiceAgreementState } from 'ogp/services/service-agreements.types';

export const useMapServiceAgreementStateToTranslation = () => {
  const { t } = useTranslation('ogp-screen-specific');
  const mapStateToTranslation = (state: ServiceAgreementState): string => {
    switch (state) {
      case 'ACCEPTED':
        return t('collegial_lending_page.service-agreement.accepted');
      case 'PENDING':
        return t('collegial_lending_page.service-agreement.pending');
      case 'REJECTED':
        return t('collegial_lending_page.service-agreement.rejected');
      case 'TERMINATED':
        return t('collegial_lending_page.service-agreement.terminated');
      default:
        assertUnreachable(state, `Unhandled service agreement state: ${state}`);
    }
  };

  return { mapStateToTranslation };
};
